import * as MuiIcons from '@mui/icons-material';

export function DynamicMuiIcon({ iconName, sx, ...rest }) {
    const IconComponent = MuiIcons[iconName] || MuiIcons['HelpOutline'];
    return <IconComponent sx={sx} {...rest} />;
}
